import $http from "./request"
import {
  getUrlParam
} from "../units/common"
export default {
  methods: {
    $tip(msg, position = "middle", argumen) {
      this.$toast({
        duration: 1000,
        forbidClick: false,
        message: msg,
        position: position,
        onClose: () => {
          argumen
        }
      })
    },
    $fail(msg, position = "middle", argumen) {
      this.$toast.fail({
        duration: 1000,
        forbidClick: false,
        message: msg,
        position: position,
        className: "toastFail",
        onClose: () => {
          argumen
        }
        // iconClass: 'icon icon-success'
      })
    },
    $success(msg, position = "middle", argumen) {
      this.$toast.success({
        duration: 800,
        forbidClick: false,
        message: msg,
        position: position,
        className: "toastSuccess",
        onClose: () => {
          argumen
        }
        // iconClass: 'icon icon-success'
      })
    },
    $setCommit(v, data) {
      this.$store.commit(v, data)
    },
    $showLoad() {
      this.$toast.loading({
        mask: false,
        message: "加载中..",
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        className: "changeDefaultToast"
      })
    },
    $hideLoad() {
      this.$toast.clear()
    },
    $confirm(message, title, confirmButtonText, showCancelButton, cancelButtonText) {
      return this.$Dialog({
        title: title,
        message: message,
        confirmButtonText: confirmButtonText,
        showCancelButton: showCancelButton,
        cancelButtonText: cancelButtonText,
      })
    },
    $get(url, params) {
      return $http({
        url: url,
        method: "get",
        params
      })
    },
    $post(url, data) {
      return $http({
        url: url,
        method: "post",
        data,
        dataType: "application/x-www-form-urlencoded"
      })
    },
    reset(node) {
      if (node.indexOf(".") > -1) {
        eval(
          "this.$data." +
          node +
          " = this.deepCopy(this.$data.defaultData." +
          node +
          ")"
        )
      } else {
        this.$data[node] = this.deepCopy(this.$data.defaultData[node])
      }
    },

    SalesmanLogin() {
      $http({
        url: "api/index/index",
        method: "POST",
        data: {
          token: localStorage.getItem("token")
        }
      }).then(result => {
        if (result.data.login_status == "404") {
          this.getSalesmanLogin()
          localStorage.setItem("login_status", 404)
          // return false;
        } else {
          localStorage.setItem("login_status", 200)
        }
      })
    },
    //业务员的登录
    getSalesmanLogin() {
      var v = 'https://m.djzysm.com/wap/#/Login'
      v = v.replace(/(&|\?)code=([^&]+)(&|)/g, "$1")
      localStorage.setItem("returnUrl", v)
      var h = encodeURIComponent(v)
      var code = getUrlParam("code")
      if (code == "") {
        location.replace(
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2f63936927c83ed6&redirect_uri=" +
          h +
          "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
        )
        // 测试id
        // location.replace(
        //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa14fc4ba226dcd8d&redirect_uri=" +
        //     h +
        //     "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
        // );
      } else {
        $http({
          url: "api/login/Getopenid",
          method: "POST",
          data: {
            code: code
          }
        }).then(result => {
          // return false;
          if (result.data.code == "200") {
            console.log(result.data);
            localStorage.setItem("user_id", result.data.user_id)
            localStorage.setItem("token", result.data.token)
            localStorage.setItem("cardcode", result.data.cardcode)
            localStorage.setItem("web_title", result.data.store_info.web_title)
            localStorage.setItem(
              "web_keywords",
              result.data.store_info.web_keywords
            )
            localStorage.setItem(
              "web_description",
              result.data.store_info.web_description
            )
            localStorage.setItem(
              "hot_search",
              result.data.store_info.hot_search
            )
            // window.location.reload()
          } else {
            this.$router.push("/Login")
          }
        })
      }
    },
    IsLogin() {
      console.log(localStorage.getItem("token"))
      $http({
        url: "api/index/index",
        method: "POST",
        data: {
          token: localStorage.getItem("token")
        }
      }).then(result => {
        if (result.data.login_status == "404") {
          this.getLogin()
          localStorage.setItem("login_status", 404)
          // return false;
        } else {
          localStorage.setItem("login_status", 200)
        }
      })
    },
    getLogin() {
      var that = this;
      var v = window.location.href
      v = v.replace(/(&|\?)code=([^&]+)(&|)/g, "$1")
      localStorage.setItem("returnUrl", v)
      var h = encodeURIComponent(v.split("#")[0])
      var code = getUrlParam("code");

      if (code == "") {
        //正式
        location.replace(
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2f63936927c83ed6&redirect_uri=" +
          h +
          "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
        )
        // 测试
        // location.replace(
        //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa14fc4ba226dcd8d&redirect_uri=" +
        //   h +
        //   "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
        // );
      } else {

        $http({
          url: "api/login/index",
          method: "POST",
          data: {
            code: code
          }
        }).then(result => {

          if (result.data.code == "200") {
            console.log(result.data)
            localStorage.setItem("user_id", result.data.user_id)
            localStorage.setItem("token", result.data.token)
            localStorage.setItem("cardcode", result.data.cardcode)
            localStorage.setItem("web_title", result.data.store_info.web_title)
            localStorage.setItem(
              "web_keywords",
              result.data.store_info.web_keywords
            )
            localStorage.setItem(
              "web_description",
              result.data.store_info.web_description
            )
            localStorage.setItem(
              "hot_search",
              result.data.store_info.hot_search
            )
            window.location.href = result.data.http_url;
            //  window.location.reload()
          } else if (result.data.code == '401') {
            // this.$router.push("/Regist")
            this.$router.push("/youke")
          } else if (result.data.code == '402') {
            this.$router.push("/oldClients")
          } else if (result.data.code == '500') {
            window.location.href = result.data.url;
          }
        })
      }
    },

    getSDKprd() {
      var that = this
      that.$post("/api/sm/jsapi", {
          token: localStorage.getItem("token")
        }).then(result => {
          var _data = result.data
          var js_api_data = _data.data
          if (_data.code == "200") {
            that.getScanCode(js_api_data)
          }
        })
        .catch(error => {
          console.error(error, "Error")
        })
    },
    getSDKprd1() {
      var that = this
      that.$post("/api/sm/jsapi", {
          token: localStorage.getItem("token")
        })
        .then(result => {
          var _data = result.data
          var js_api_data = _data.data
          if (_data.code == "200") {
            that.getScanCode1(js_api_data, '1')
          }
        })
        .catch(error => {
          console.error(error, "Error")
        })
    },
    getScanCode1(_data) {
      wx.config({
        debug: false,
        appId: _data.appId,
        timestamp: _data.timestamp,
        nonceStr: _data.nonceStr,
        signature: _data.signature,
        jsApiList: ["scanQRCode", "getLocation"]
      })
    },

    getScanCode(_data) {
      var that = this
      wx.config({
        debug: false,
        appId: _data.appId,
        timestamp: _data.timestamp,
        nonceStr: _data.nonceStr,
        signature: _data.signature,
        jsApiList: ["scanQRCode", "getLocation"]
      })
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            if (res.resultStr.indexOf('http') == -1) {
              var serial = res.resultStr.split(",");
              var barCode = serial[serial.length - 1];
              let order_no = barCode;
              that.$post("/api/Sm/index", {
                itemcode: order_no
              }).then(result => {
                if (result.data.code == "200") {
                  //1为单个商品.跳转详情
                  console.log(result.data)
                  if (result.data.type == 1) {
                    that.$router.replace({
                      path: "/productdetail",
                      query: {
                        itemcode: result.data.itemcode
                      }
                    })
                  } else if (result.data.type == 2) {
                    that.$router.push({
                      path: "/smsearch",
                      query: {
                        itemcode: result.data.itemcode
                      }
                    })
                  }
                } else {
                  that.$tip("暂无此条码商品")
                  that.$router.push("/error")
                }
              }).catch(error => {
                console.error(error, "Error")
              })
            } else {
              return that.$Dialog({
                title: '提示',
                message: '请扫条形码',
              }).then(() => {
                // this.$router.go(-1)
              });
            }
          },
          error: function(err) {
            console.error(err)
          }
        })
      })
    },
    _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i]
        }
        return arr2
      } else {
        return Array.from(arr)
      }
    },
    deepCopy(val) {
      return JSON.parse(JSON.stringify(val))
    },
    timetrans(date) {
      if (date < 10000000001) {
        date = date * 1000
      }
      var date = new Date(date) //如果date为10位不需要乘1000
      var Y = date.getFullYear() + "-"
      var M =
        (date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1) + "-"
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " "
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":"
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":"
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + " " + h + m + s
    },
    getObjectURL(file) {
      var url = null
      if (window.createObjectURL != undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    }
  }
}



// WEBPACK FOOTER //
// ./src/units/baseMixin.js